// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/._css-loader@0.28.4@css-loader/index.js??ref--11-1!../node_modules/._postcss-loader@1.3.3@postcss-loader/index.js??postcss!../node_modules/._stylus-loader@3.0.1@stylus-loader/index.js??ref--11-3!./styles.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../node_modules/._style-loader@0.13.2@style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/._css-loader@0.28.4@css-loader/index.js??ref--11-1!../node_modules/._postcss-loader@1.3.3@postcss-loader/index.js??postcss!../node_modules/._stylus-loader@3.0.1@stylus-loader/index.js??ref--11-3!./styles.styl", function() {
			var newContent = require("!!../node_modules/._css-loader@0.28.4@css-loader/index.js??ref--11-1!../node_modules/._postcss-loader@1.3.3@postcss-loader/index.js??postcss!../node_modules/._stylus-loader@3.0.1@stylus-loader/index.js??ref--11-3!./styles.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src/styles.styl
// module id = ../../../../../src/styles.styl
// module chunks = 4